module.exports = __webpack_public_path__ + "static/media/mobile-app.ee47cb61.jpg";